module.exports = __webpack_public_path__ + "static/media/user.b5b1612e.svg";